export default __webpack_public_path__ + "static/media/guest.6eb48000.jpg";